export enum AssetForType {
    diagnosticReport = 'diagnosticReport',
    employment = 'employment',
    practitioner = 'practitioner',
    procedure = 'procedure',
    processActivity = 'processActivityId',
    request = 'request',
}
